import { api, ApiError } from '../api';

/**
 * What ⌘Z can take back in the calendar (owner remark 28): a move, a copy or a deletion made there. A move and a
 * copy keep the version the event had right after them: undoing sends it, so a later change by anyone is not
 * overwritten (409 → not undone).
 */
export type UndoStep =
  | { kind: 'move'; id: string; name: string; version: number; before: { startsAt: string; endsAt: string } }
  | { kind: 'copy'; id: string; name: string; version: number }
  | { kind: 'delete'; id: string; name: string };

/** Steps kept (newest last). In memory only: gone after a reload, as asked ("stos w pamięci sesji"). */
export const UNDO_LIMIT = 20;
const stack: UndoStep[] = [];

export function pushUndo(step: UndoStep): void {
  stack.push(step);
  if (stack.length > UNDO_LIMIT) stack.splice(0, stack.length - UNDO_LIMIT);
}
export const popUndo = (): UndoStep | undefined => stack.pop();
export const undoSize = (): number => stack.length;
export function clearUndo(): void {
  stack.length = 0;
}

/** Said when the event changed after the step (409): the step is dropped (it was taken off the stack). */
export const CHANGED_SINCE = 'Wydarzenie zmieniło się — nie cofnięto';

/** Takes the step back on the server and says what happened; throws `CHANGED_SINCE` when the event changed since. */
export async function applyUndo(step: UndoStep): Promise<string> {
  try {
    if (step.kind === 'delete') {
      await api(`/api/events/${step.id}/restore`, { method: 'POST' });
      return `Cofnięto usunięcie „${step.name}”.`;
    }
    if (step.kind === 'move') {
      await api(`/api/events/${step.id}`, { method: 'PATCH', body: { ...step.before, version: step.version } });
      return `Cofnięto przeniesienie „${step.name}”.`;
    }
    await api(`/api/events/${step.id}?version=${step.version}`, { method: 'DELETE' });
    return `Cofnięto kopię „${step.name}” (kopia usunięta).`;
  } catch (error) {
    if (error instanceof ApiError && error.status === 409) throw new Error(`${CHANGED_SINCE} („${step.name}”).`);
    throw error;
  }
}
